import React, { useEffect, useRef, useState } from 'react';
import DataTableCell from '../DataTableCell';

export interface BooleanFieldProps {
  initialValue: boolean;
  onChange: (val: boolean) => void;
}

const BooleanField: React.FC<BooleanFieldProps> = ({ initialValue, onChange }) => {
  const [selected, setSelected] = useState(initialValue);

  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      onChange(selected);
    } else {
      didMountRef.current = true;
    }
  }, [selected, onChange]);

  return (
    <DataTableCell>
      <select
        onChange={(e) => setSelected(e.target.value === 'yes')}
        value={selected ? 'yes' : 'no'}
      >
        <option value='yes'>Yes</option>
        <option value='no'>No</option>
      </select>
    </DataTableCell>
  );
};

export default BooleanField;
